import React from 'react';
import './ErDiagram.scss';
import HeaderPrint from "../HeaderPrint/HeaderPrint";

const ErDiagram = ({data}) => {

  try {
    return (
      <>
        {data?.data?.data.map((item, index) => (
          <React.Fragment key={index}>
            <section className='er_diagram'>
              <HeaderPrint
                persianTitle={"نمودار ER"}
                englishTitle={"ER  diagram"}
                color={"#FF7300"}
              />
              <div className='form_info'>
                <div className='info_box'>
                  <div className='box_child'>
                    <span className='iransans'>کاربـر :</span>
                    <span className='iransans'>{item.user}</span>
                  </div>
                </div>
                <div className='info_box'>
                  <div className='box_child'>
                    <span className='iransans'>تاریخ :</span>
                    <span className='iransans'>{item.date}</span>
                  </div>
                </div>
              </div>
              <div className='container_boxes'>
                <div className='diagram_box iransans'>
                  {item.ErUrl && <img src={item.ErUrl} alt="نمودار ER"/>}
                </div>
                <div className='description_box iransans'>توضیحات</div>
              </div>
            </section>
            {index < data?.data?.data.length - 1 && (
              <div style={{pageBreakBefore: "always"}}></div>
            )}
          </React.Fragment>
        ))}
      </>
    );
  } catch (e) {
    return <>{e.toLocaleString()}</>
  }
};

export default ErDiagram;